
import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { resetDepositSubmitState } from 'src/features'

const CreditCardForm = ({ payload }) => {
  const dispatch = useAppDispatch()
  const { submit } = useAppSelector((state) => state.summary.deposit)
  useEffect(() => {
    if (submit){
      // @ts-ignore
      document.getElementById('tpvForm').submit()
    }
    return (() => {
      dispatch(resetDepositSubmitState())
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submit])

  return (
    <>
      <form
        id='tpvForm'
        name='form'
        action={process.env.REDYS_PAID_URL}
        method='POST'
      >
        <input
          type='hidden'
          name='Ds_SignatureVersion'
          value={payload?.Ds_SignatureVersion}
        />
        <input
          type='hidden'
          name='Ds_MerchantParameters'
          value={payload?.Ds_MerchantParameters}
        />
        <input type='hidden' name='Ds_Signature' value={payload?.Ds_Signature} />
        <input
          type='submit'
          name='btnPayCC'
          id='btnPayCC'
          data-testid='btnPayCC-test'
          style={{
            display: 'none',
          }}
        ></input>
      </form>
    </>
  )
}

export default CreditCardForm
